import React from 'react';
import { Link } from 'react-router-dom';

export default function ProductNotFound({ error }) {  
    return (
        <div className="vh-100 d-flex align-items-center justify-content-center">
            <div className="text-center">
                <h1 className="display-1 fw-bold">Oops!</h1>
                <p className="fs-3">
                    <span className="text-danger">Sorry, </span> 
                    an unexpected error has occurred. Please choose another product. 
                </p>

                <p className="lead">
                    {'No additional details available.'}
                </p>
                <Link to="/home-page" className="btn btn-primary text-white">
                    Go Home
                </Link>
            </div>
        </div>
    );
}
